import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { BulkEmailStartReducer } from "../_redux/_services/UserManagerSlice";

const EmailDeliverySummary = ({ candidateMailId = null }) => {
    const [skippedRecipients, setSkippedRecipients] = useState(null);
    const [skippedCcRecipients, setSkippedCcRecipients] = useState(null);
    const [deliverySummary, setDeliverySummary] = useState(null);
    const [ccProvided, setCcProvided] = useState(false);
    const [openDndStatusModal, setOpenDndStatusModal] = useState(false);
    const dispatch = useDispatch();
    const initalState = { data: null, code: null, message: '', isLoading: false };
    const { data: BulkEmail, code: BulkEmailCode } = useSelector((state) => state.BulkEmail);

    useEffect(() => {
        if (BulkEmailCode === 200) {
            setOpenDndStatusModal(true);
            setSkippedRecipients(BulkEmail?.unsubscribedRecipients ?? null);
            setSkippedCcRecipients(BulkEmail?.unsubscribedCcRecipients ?? null);
            setDeliverySummary(BulkEmail?.deliverySummary ?? null);
            setCcProvided(BulkEmail?.ccProvided ?? false);
            dispatch(BulkEmailStartReducer(initalState));
        }
    }, [BulkEmailCode, BulkEmail]);

    const closeEmailDeliverySummaryModal = () => {
        setOpenDndStatusModal(false);
        setSkippedRecipients(null);
        setSkippedCcRecipients(null);
        setDeliverySummary(null);
        setCcProvided(false);
        dispatch(BulkEmailStartReducer(initalState));
    }

    useEffect(() => {
        console.log("skippedRecipients", skippedRecipients);
        console.log("skippedCcRecipients", skippedCcRecipients);
        console.log("deliverySummary", deliverySummary);
        console.log("ccProvided", ccProvided);
        console.log("openDndStatusModal", openDndStatusModal);
        console.log("candidateMailId +++++++++++++", candidateMailId);
    }, [skippedRecipients, skippedCcRecipients, deliverySummary, ccProvided, openDndStatusModal, candidateMailId])


    return (
        < Dialog
            open={openDndStatusModal}
            onClose={closeEmailDeliverySummaryModal}
            maxWidth="sm"
            fullWidth
            disableRestoreFocus={true}
            disableScrollLock={true}
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                    overflow: "hidden",
                }
            }}
        >
            <DialogTitle
                sx={{
                    backgroundColor: "var(--secondary-bg-color, #373d49)",
                    color: "var(--secondary-background-text-color, #ffffff)",
                    textAlign: "left",
                    fontWeight: 600,
                    position: "relative",
                    fontSize: "18px",
                    padding: "16px 24px",
                }}
            >
                Email Status
                <span
                    style={{
                        position: "absolute",
                        right: 20,
                        top: 15,
                        cursor: "pointer",
                        color: "#ef4444",
                        fontSize: "20px",
                        fontWeight: "bold",
                    }}
                    onClick={closeEmailDeliverySummaryModal}
                >
                    ✕
                </span>
            </DialogTitle>

            <DialogContent sx={{ padding: "24px", backgroundColor: "#ffffff" }}>
                <div
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#000000",
                        margin: "16px 0",
                    }}
                >
                    Email sent to:{" "}
                    {deliverySummary !== null ? (
                        <span style={{ color: "#0B8924", fontWeight: "700" }}>
                            {deliverySummary?.successfullySent} out of {deliverySummary?.totalRecipients} recipients
                        </span>
                    ) : (
                        <span style={{ color: "#0B8924", fontWeight: "700" }}>
                            {candidateMailId}
                        </span>
                    )}
                </div>
                {deliverySummary !== null && (
                    <div
                        style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            color: "#000000",
                            marginBottom: "16px",
                            marginTop: "24px",
                        }}
                    >
                        {deliverySummary?.skippedRecipients} Skipped recipients (Unsubscribed):
                    </div>
                )}
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        marginTop: "16px",
                    }}
                >
                    {skippedRecipients?.length > 0 && skippedRecipients?.map((list, index) => (
                        <div
                            key={index}
                            style={{
                                flex: "1 1 calc(50% - 6px)",
                                boxSizing: "border-box",
                                minWidth: "200px",
                                padding: "9px 10px",
                                borderRadius: "12px",
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#fafafa",
                                color: "#000000",
                                fontSize: "15px",
                                textAlign: "left",
                            }}
                        >
                            {list}
                        </div>
                    ))}
                </div>
                {ccProvided === true && (
                    <>
                        <div
                            style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "#000000",
                                marginBottom: "16px",
                                marginTop: "24px",
                            }}
                        >
                            {skippedCcRecipients && skippedCcRecipients?.length} Skipped cc recipients (Unsubscribed):
                        </div>
                        <div
                            style={{
                                
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "12px",
                                marginTop: "16px",
                            }}
                        >
                            {skippedCcRecipients?.length > 0 && skippedCcRecipients?.map((list, index) => (
                                <div
                                    key={index}
                                    style={{
                                        flex: "1 1 calc(50% - 6px)",
                                        boxSizing: "border-box",
                                        minWidth: "200px",
                                        padding: "9px 10px",
                                        borderRadius: "12px",
                                        border: "1px solid #e0e0e0",
                                        backgroundColor: "#fafafa",
                                        color: "#000000",
                                        fontSize: "15px",
                                        textAlign: "left",
                                    }}
                                >
                                    {list}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </DialogContent>
        </Dialog >
    );
};

export default EmailDeliverySummary;